module.exports = __webpack_public_path__ + "static/media/apps.25e6d2cc.svg";